import { useState, useEffect } from "react";
import api from "../utils/apiConfig";

import logger from '../utils/logger';

export const useAnnualReview = (householdId) => {
  const [annualReviewData, setAnnualReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnualReview = async () => {
      try {
        setLoading(true);

        // First, get available years and versions
        const availableReviewsResponse = await api.get(
          `/advisor-portal/client-database/household-profile/${householdId}/ar-profile/available`,
        );

        if (
          !availableReviewsResponse.data ||
          availableReviewsResponse.data.length === 0
        ) {
          logger.info("No annual reviews available");
          setAnnualReviewData(null);
          return;
        }

        // Get the most recent year and version
        const { year, version } = availableReviewsResponse.data[0];

        // Fetch the data for the most recent year and version
        const response = await api.get(
          `/advisor-portal/client-database/household-profile/${householdId}/ar-profile/${year}/${version}`,
        );

        setAnnualReviewData(response.data);
      } catch (error) {
        // Only log if it's not a 404 (which is expected if no annual reviews exist)
        if (error.response?.status !== 404) {
          logger.error("Error fetching annual review:", error);
          setError(error.message);
        }
        setAnnualReviewData(null);
      } finally {
        setLoading(false);
      }
    };

    if (householdId) {
      fetchAnnualReview();
    }
  }, [householdId]);

  return { annualReviewData, loading, error };
};
